import { render, staticRenderFns } from "./helpPro.vue?vue&type=template&id=2b7a253a&scoped=true"
import script from "./helpPro.vue?vue&type=script&lang=js"
export * from "./helpPro.vue?vue&type=script&lang=js"
import style0 from "./helpPro.vue?vue&type=style&index=0&id=2b7a253a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a253a",
  null
  
)

export default component.exports